module.exports = __webpack_public_path__ + "img/redtiger.441af4f3.png";